export const SET_STATE = "SET_STATE"
export const ADD_ALERT = "ADD_ALERT"

export const LOGIN = "LOGIN"
export const LOGOUT = "LOGOUT"

export const REFRESH_USERS = "REFRESH_USERS"
export const CREATE_USER = "CREATE_USER"
export const DELETE_USER = "DELETE_USER"
export const UPDATE_USER = "UPDATE_USER"
export const UPDATE_PASSWORD = "UPDATE_PASSWORD"

export const REFRESH_DEALERS = "REFRESH_DEALERS"
export const CREATE_DEALER = "CREATE_DEALER"
export const DELETE_DEALER = "DELETE_DEALER"
export const UPDATE_DEALER = "UPDATE_DEALER"

export const REFRESH_ORDERS = "REFRESH_ORDERS"
export const CREATE_ORDER = "CREATE_ORDER"
export const DELETE_ORDER = "DELETE_ORDER"
export const UPDATE_ORDER = "UPDATE_ORDER"

export const REFRESH_RETURNS = "REFRESH_RETURNS"
export const CREATE_RETURN = "CREATE_RETURN"
export const DELETE_RETURN = "DELETE_RETURN"
export const UPDATE_RETURN = "UPDATE_RETURN"

export const REFRESH_EXPENSES = "REFRESH_EXPENSES"
export const CREATE_EXPENSE = "CREATE_EXPENSE"
export const DELETE_EXPENSE = "DELETE_EXPENSE"
export const UPDATE_EXPENSE = "UPDATE_EXPENSE"



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js